(() => {
  const formSelector = '[data-cart-checkout-form]';
  const checkboxSelector = '[data-cart-terms-checkbox]';

  const syncButton = (form) => {
    const checkbox = form.querySelector(checkboxSelector);
    const button = form.querySelector('button[name="checkout"]');
    if (checkbox && button) {
      button.disabled = !checkbox.checked;
    }
  };

  // Delegation also covers cart forms replaced by Shopify section rendering.
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.matches(checkboxSelector)) return;
    const form = event.target.closest(formSelector);
    if (form) syncButton(form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(formSelector)) return;
    const checkbox = form.querySelector(checkboxSelector);
    if (checkbox && !checkbox.checked) {
      event.preventDefault();
      syncButton(form);
      checkbox.reportValidity();
    }
  }, true);

  // Restore the matching button state when returning via the browser's Back button.
  const syncForms = () => document.querySelectorAll(formSelector).forEach(syncButton);
  window.addEventListener('pageshow', syncForms);
  syncForms();
})();
